import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Megapack Anti Pantalla — El Sistema Más Completo de Argentina';
// Preconnect to CDN
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// DNS-prefetch for Facebook (deferred pixel)
const dnsPrefetchFb = document.createElement('link');
dnsPrefetchFb.rel = 'dns-prefetch';
dnsPrefetchFb.href = 'https://connect.facebook.net';
document.head.appendChild(dnsPrefetchFb);
// Preload the actual hero/LCP image
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.type = 'image/webp';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/qjMZ9B74wu1wrmtYGYNm8K/hf_20260414_012954_115573b9-1bb3-4273-9ad0-c15d1fe6219c-Photoroom.webp';
document.head.appendChild(preloadImg);
render(<App data-id="element-352" />, document.getElementById('root'));